module.exports = __webpack_public_path__ + "img/sl1.03a01f23.png";